import { createActionConfig } from './create-action-config';

export const type = '@appcues/no-op';
export const getNoOp = () =>
  createActionConfig({
    type,
  });
